module.exports = __webpack_public_path__ + "static/media/wavm8s-008-tal-bot.970f873.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-008-tal-bot.mp3
// module id = t9sY
// module chunks = 0